const productForm = document.querySelectorAll("[data-type]");

const getCart = async () => {
  const res = await fetch("/cart.json");
  const cart = await res.json();
  return cart;
};

const isConsultationInCart = (cart, consultationId) => {
  const cartItemsIds = cart.items.map((item) => {
    return item.product_id;
  });

  return cartItemsIds.includes(parseInt(consultationId));
};

// productForm.forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();
//     const EARA_PRODUCT_ID = "7486207000639";
//     const CONSULTATION_PRODUCT_ID = "7654080151615";
//     const CONSULTATION_HANDLE = "free-audiologist-consultations";
//     const productId = form.dataset.productId;
//     const cart = await getCart();

//     if (isConsultationInCart(cart, CONSULTATION_PRODUCT_ID)) return;

//     if (productId === EARA_PRODUCT_ID) {
//       let productData = {};
//       try {
//         const resp = await fetch(
//           `${window.Shopify.routes.root}products/${CONSULTATION_HANDLE}.js`
//         );

//         const product = await resp.json();

//         const variantId = product.variants[0].id;
//         productData = {
//           id: variantId,
//           quantity: 1,
//         };
//       } catch (error) {
//         console.error(error);
//       }

//       const requestBody = {
//         items: [productData],
//       };
//       try {
//         const cartResponse = await fetch(
//           `${window.Shopify.routes.root}cart/add.js`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(requestBody),
//           }
//         );
//         const cartDrawer = document.getElementById("MinimogCartDrawer");
//         cartDrawer.onCartDrawerUpdate();
//       } catch (error) {
//         console.error(error);
//       }
//     }
//   });
// });
